// @flow
import React from 'react';
import { css } from 'react-emotion';
import { colors } from '../assets/scripts/constants';

/**
 * Styles
 */

const aCss = css`
  color: ${colors.orange};
  text-decoration: none;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`;

/**
 * Component: A (anchor)
 *
 * General anchor component.
 */
export default function A(props: {
  children: Object | string,
  href: string,
  target?: string,
}) {
  const { children, href, target } = props;
  return (
    <a
      className={aCss}
      href={href}
      target={target}
      rel={`${target === '_blank' ? 'noopener noreferrer' : ''}`}
    >
      {children}
    </a>
  );
}

A.defaultProps = {
  target: null,
};



// WEBPACK FOOTER //
// ./src/components/A.js